import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { type JSX, type ReactNode, useState } from 'react';
import { DEFAULT_QUERY_STALE_TIME_MS } from '../lib/queryDefaults';
import {
  DataProviderProvider,
  createDataProvider,
  resolveEffectiveDataMode,
} from '@/data/provider';

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps): JSX.Element {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: DEFAULT_QUERY_STALE_TIME_MS,
            refetchOnWindowFocus: false,
          },
        },
      })
  );
  const [dataProvider] = useState(() => createDataProvider(resolveEffectiveDataMode()));

  return (
    <QueryClientProvider client={queryClient}>
      <DataProviderProvider provider={dataProvider}>
        {children}
        {/* <ReactQueryDevtools buttonPosition="bottom-left" initialIsOpen={false} /> */}
      </DataProviderProvider>
    </QueryClientProvider>
  );
}
